import { getFieldOnMainLanguage } from '@app/utils/languages';
import DragHandleIcon from '@mui/icons-material/DragHandle';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';

import { GenericObject } from '@app/components/common/Table/DefaultTable/types';

interface TreeLeafProps {
  taxonomy: GenericObject;
  orderable?: boolean;
  handleClick?(taxonomy: GenericObject): void;
}

export const TreeLeaf = ({ taxonomy, orderable, handleClick }: TreeLeafProps) => {
  return (
    <div
      aria-hidden="true"
      onClick={() => !!(!orderable && handleClick) && handleClick(taxonomy)}
      style={{ padding: 10, display: 'flex', cursor: 'pointer', alignItems: 'center' }}>
      {orderable && (
        <div style={{ marginLeft: 44 }}>
          <DragHandleIcon />
        </div>
      )}
      <div style={{ marginLeft: orderable ? 10 : 44 }}>
        <InsertDriveFileIcon />
      </div>
      <div data-cy="taxonomy-name" style={{ marginLeft: 10 }}>
        {getFieldOnMainLanguage(taxonomy?.category_name)}
      </div>
    </div>
  );
};
